import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { TimeTrackingActivityCompilation } from './timeTrackingActivityCompilationTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class TimeTrackingActivityCompilationRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.TimeTrackingActivityCompilation,
  AppEntityManagerEntityTypesByEntityName
> {
  public getByUserGroupId(
    userGroupId: string
  ): Array<TimeTrackingActivityCompilation> {
    return this.getAll().filter(
      (compilation) => compilation.ownerUserGroupId === userGroupId
    );
  }
}
